import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logoutIcon, mainLogo } from '@/assets/images'
import './index.less'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setAuthority, setToken, setUserId } from '@/features/Login/login'
import { DataPage } from './DataPage'
import { UserPage } from './UserPage'
import { DashboardPage } from './DashboardPage'
import { Checkbox, Form, Input, message, Modal, Row, Select } from 'antd'
import { DashboardOutlined, IdcardOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { getManageList, insertManageItem, saveManageItem } from '@/server'

const { Search } = Input

export function AdminPage() {
  const dispatch = useAppDispatch()
  // 0:仪表盘 1:用户管理 2:数组管理
  const [component, setComponent] = useState(0)

  // 新建
  const [userOpen, setUserOpen] = useState(false)
  const [groupOpen, setGroupOpen] = useState(false)
  const [ruleOpen, setRuleOpen] = useState(false)
  const [userForm] = Form.useForm()
  const [groupForm] = Form.useForm()
  const [ruleForm] = Form.useForm()

  const [userOptions, setUserOptions] = useState(Array<any>)
  const [groupOptions, setGroupOptions] = useState(Array<any>)
  const [ruleOptions, setRuleOptions] = useState(Array<any>)
  const [groupToId, setGroupToId] = useState({})
  const [ruleToId, setRuleToId] = useState({})

  const openList = [userOpen, groupOpen, ruleOpen]
  const setOpenList = [setUserOpen, setGroupOpen, setRuleOpen]
  const titleList = ['新建成员', '新建分组', '新建规则']
  const formList = [userForm, groupForm, ruleForm]
  const typeList = ['user', 'group', 'rule']
  const token = useAppSelector((state) => state.login.token)
  const navigate = useNavigate()
  const handleBackHome = () => {
    if (token) navigate('/index')
    else navigate('/')
  }
  const handleLogout = () => {
    dispatch(setAuthority(-1))
    dispatch(setToken(''))
    dispatch(setUserId(''))
    navigate('/')
    message.success('退出成功！')
  }

  const userRef: any = useRef(null)
  const ruleRef: any = useRef(null)

  const onAdd = (type, values) => {
    switch (type) {
      case 'user':
        insertManageItem(
          {
            username: values.loginName,
            displayname: values.displayName,
            email: values.email,
            groupid: groupToId[values.group],
            password: values.password,
            enable: true
          },
          'user',
          token
        )
          .then((_res) => {
            message.success('添加成功！')
            setUserOpen(false)
            getBackendData()
            userRef.current.rerender()
          })
          .catch((err) => {
            message.error('添加失败，请重试！')
            console.log(err)
          })
        break
      case 'group':
        saveManageItem(
          {
            groupadmin: values.groupAdmin,
            groupname: values.groupName,
            rules: values.rules.map((item) => ruleToId[item]),
            groupmembers: values.selectUsers.selectUsers
          },
          'group',
          token
        )
          .then((_res) => {
            message.success('添加成功！')
            setGroupOpen(false)
            getBackendData()
            userRef.current.rerender()
          })
          .catch((err) => {
            message.error('添加失败，请重试！')
            console.log(err)
          })
        break
      case 'rule':
        saveManageItem(
          {
            rulename: values.ruleName,
            urls: values.dataPath,
            permission: values.permission,
            used: values.used.map((item) => groupToId[item])
          },
          'rule',
          token
        )
          .then((_res) => {
            message.success('添加成功！')
            setRuleOpen(false)
            getBackendData()
            ruleRef.current.rerender()
          })
          .catch((err) => {
            message.error('添加失败，请重试！')
            console.log(err)
          })
        break
    }
    getBackendData()
  }

  const dataPathOptions = [
    {
      value: 'author_avatar',
      label: 'author_avatar'
    },
    {
      value: 'inst_avatar',
      label: 'inst_avatar'
    },
    {
      value: 'tcp_thumbnails',
      label: 'tcp_thumbnails'
    },
    {
      value: 'tcp01tiles512',
      label: 'tcp01tiles512'
    },
    {
      value: 'tcp02tiles512',
      label: 'tcp02tiles512'
    },
    {
      value: 'tcp03tiles512',
      label: 'tcp03tiles512'
    },
    {
      value: 'tcp04tiles512',
      label: 'tcp04tiles512'
    },
    {
      value: 'tcp05tiles512',
      label: 'tcp05tiles512'
    }
  ]
  const permissionOptions = [
    {
      value: '只读',
      label: '只读'
    },
    {
      value: '读写',
      label: '读写'
    },
    {
      value: '禁止访问',
      label: '禁止访问'
    }
  ]

  let userList: Array<string> = []
  let groupList: Array<string> = []
  let ruleList: Array<string> = []
  const getBackendData = () => {
    getManageList({}, 'user', token)
      .then((res) => {
        userList = []
        for (const user of res.data.content) {
          userList.push(user.username)
        }
        const tmpUserOptions = userList.map((item) => {
          return {
            value: item,
            label: item
          }
        })
        setUserOptions(tmpUserOptions)
      })
      .catch((err) => {
        console.log(err)
      })
    getManageList({}, 'group', token)
      .then((res) => {
        groupList = []
        const tmpGroupToId = {}
        for (const group of res.data.content) {
          groupList.push(group.groupname)
          tmpGroupToId[group.groupname] = group.groupid
        }
        const tmpGroupOptions = groupList.map((item) => {
          return {
            value: item,
            label: item
          }
        })
        setGroupOptions(tmpGroupOptions)
        setGroupToId(tmpGroupToId)
      })
      .catch((err) => {
        console.log(err)
      })
    getManageList({}, 'rule', token)
      .then((res) => {
        ruleList = []
        const tmpRuleToId = {}
        for (const rule of res.data.content) {
          ruleList.push(rule.rulename)
          tmpRuleToId[rule.rulename] = rule.ruleid
        }
        const tmpRuleOptions = ruleList.map((item) => {
          return {
            value: item,
            label: item
          }
        })
        setRuleOptions(tmpRuleOptions)
        setRuleToId(tmpRuleToId)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  useEffect(() => {
    getBackendData()
  }, [])

  const userFormNode = (
    <Form
      form={userForm}
      layout='vertical'
      name='user'
      initialValues={{
        modifier: 'public'
      }}
    >
      <Form.Item
        name='loginName'
        label='用户名'
        rules={[
          {
            required: true,
            message: '请输入成员用户名'
          }
        ]}
      >
        <Input placeholder='请输入成员用户名' />
      </Form.Item>
      <Form.Item
        name='displayName'
        label='显示姓名'
        rules={[
          {
            required: true,
            message: '请输入成员显示姓名'
          }
        ]}
      >
        <Input placeholder='请输入成员显示姓名' />
      </Form.Item>
      <Form.Item
        name='password'
        label='密码'
        rules={[
          {
            required: true,
            message: '请输入成员登录密码'
          }
        ]}
      >
        <Input.Password placeholder='请输入成员登录密码' />
      </Form.Item>
      <Form.Item
        name='email'
        label='电子邮件'
        rules={[
          {
            required: false,
            message: '请输入成员电子邮件'
          }
        ]}
      >
        <Input placeholder='请输入成员电子邮件' />
      </Form.Item>
      <Form.Item
        name='group'
        label='分组'
        rules={[
          {
            required: true,
            message: '请选择成员分组'
          }
        ]}
      >
        <Select options={groupOptions} />
      </Form.Item>
      {/* <Form.Item
        name="isAdmin"
        label="是否设置该用户为该组管理员"
        rules={[
          {
            required: true,
            message: "请选择"
          }
        ]}
      >
        <Switch />
      </Form.Item> */}
    </Form>
  )

  interface UserSelectValue {
    selectUsers?: Array<string>
  }

  interface UserSelectProps {
    value?: UserSelectValue
    onChange?: (value: UserSelectValue) => void
  }

  const UserSelect: React.FC<UserSelectProps> = ({ value, onChange }) => {
    const [selectUsers, setSelectUsers] = useState([])
    const [totalUsers, setTotalUsers] = useState(userOptions)

    const triggerChange = (changedValue) => {
      onChange?.({
        selectUsers,
        ...value,
        ...changedValue
      })
    }

    const handleSearchChange = (e) => {
      console.log(e.target.value)
      const curTotalUsers: Array<any> = []
      for (const user of userOptions) {
        if (user.value.startsWith(e.target.value)) {
          curTotalUsers.push({
            value: user.value,
            label: user.label
          })
        }
      }
      setTotalUsers(curTotalUsers)
    }
    const handleCheckboxChange = (checkedValues) => {
      console.log(checkedValues)
      setSelectUsers(checkedValues)
      triggerChange({
        selectUsers: checkedValues
      })
    }

    return (
      <div className='select-user'>
        <div className='select-user-header'>
          <div className='select-user-header-left'>已选用户（{selectUsers.length}）</div>
          <div className='select-user-header-right'>用户列表</div>
        </div>
        <div className='select-user-body'>
          <div className='cur-select-user'>
            {selectUsers.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </div>
          <div className='user-list'>
            <Search placeholder='输入进行搜索' onChange={handleSearchChange} />
            <Checkbox.Group
              onChange={handleCheckboxChange}
              style={{ display: 'block', overflow: 'auto' }}
            >
              {totalUsers.map((item) => (
                <Row style={{ marginTop: 5 }}>
                  <Checkbox value={item.value}>{item.label}</Checkbox>
                </Row>
              ))}
            </Checkbox.Group>
          </div>
        </div>
      </div>
    )
  }

  const _checkSelectUsers = (value) => {
    if (value.length > 0) {
      return Promise.resolve()
    }
    return Promise.reject(new Error('分组人数不能为空！'))
  }

  const groupFormNode = (
    <Form
      form={groupForm}
      layout='vertical'
      name='group'
      initialValues={{
        modifier: 'public'
      }}
    >
      <Form.Item
        name='groupName'
        label='组名'
        rules={[
          {
            required: true,
            message: '请输入组名'
          }
        ]}
      >
        <Input placeholder='请输入组名' />
      </Form.Item>
      <Form.Item
        name='groupAdmin'
        label='组管理员'
        rules={[
          {
            required: true,
            message: '请选择组管理员'
          }
        ]}
      >
        <Select options={userOptions} />
      </Form.Item>
      <Form.Item
        name='rules'
        label='适用规则'
        rules={[
          {
            required: true,
            message: '请选择适用规则'
          }
        ]}
      >
        <Select mode='multiple' options={ruleOptions} />
      </Form.Item>
      <Form.Item
        name='selectUsers'
        // rules={[
        //   {
        //     validator: checkSelectUsers
        //   }
        // ]}
      >
        <UserSelect />
      </Form.Item>
    </Form>
  )

  const ruleFormNode = (
    <Form
      form={ruleForm}
      layout='vertical'
      name='rule'
      initialValues={{
        modifier: 'public'
      }}
    >
      <Form.Item
        name='ruleName'
        label='规则名称'
        rules={[
          {
            required: true,
            message: '请输入规则名称'
          }
        ]}
      >
        <Input placeholder='请输入规则名称' />
      </Form.Item>
      <Form.Item
        name='dataPath'
        label='数据路径'
        rules={[
          {
            required: true,
            message: '请选择数据路径'
          }
        ]}
      >
        <Select mode='multiple' options={dataPathOptions} />
      </Form.Item>
      <Form.Item
        name='used'
        label='可用于'
        rules={[
          {
            required: true,
            message: '请选择适用范围'
          }
        ]}
      >
        <Select mode='multiple' options={groupOptions} />
      </Form.Item>
      <Form.Item
        name='permission'
        label='权限'
        rules={[
          {
            required: true,
            message: '请选择权限'
          }
        ]}
      >
        <Select options={permissionOptions} />
      </Form.Item>
    </Form>
  )

  const formNodeList = [userFormNode, groupFormNode, ruleFormNode]

  const modalList = openList.map((_item, index) => {
    return (
      <Modal
        open={openList[index]}
        title={titleList[index]}
        okText='确定'
        cancelText='取消'
        onCancel={() => {
          setOpenList[index](false)
        }}
        onOk={() => {
          formList[index]
            .validateFields()
            .then((values) => {
              formList[index].resetFields()
              onAdd(typeList[index], values)
            })
            .catch((info) => {
              console.log('Validate Failed:', info)
            })
        }}
      >
        {formNodeList[index]}
      </Modal>
    )
  })

  return (
    <div className='admin-container'>
      <div className='admin-header-container'>
        <div className='admin-header-title'>
          <img src={mainLogo} alt='大标题' onClick={handleBackHome} />
        </div>
        <div className='admin-header-menu'>
          {/* <div className="admin-header-menu-item" onClick={handleBackHome}>
            首 页
          </div>
          <div className="admin-header-menu-item">团队介绍</div>
          <div className="admin-header-menu-item">“大系全集”</div>
          <div className="admin-header-menu-item">专题画作</div>
          <div className="admin-header-menu-item">联系我们</div> */}
        </div>
        <div className='admin-header-btn'>
          <div className='admin-logo' title='退出登录' onClick={handleLogout}>
            <img src={logoutIcon} alt='退出登录' />
          </div>
        </div>
      </div>
      <div className='admin-body-container'>
        {modalList}
        <div className='admin-body-menu'>
          <div className='buttons-container'>
            <button
              className={component === 0 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={(_e) => {
                setComponent(0)
              }}
            >
              <DashboardOutlined />
              <span className='button-text'>数据概览</span>
            </button>
            <button
              className={component === 1 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={(_e) => {
                setComponent(1)
              }}
            >
              <IdcardOutlined />
              <span className='button-text'>用户管理</span>
            </button>
            {component === 1 && (
              <div>
                <button
                  className='admin-little-menu'
                  onClick={() => {
                    setUserOpen(true)
                  }}
                >
                  <PlusCircleOutlined style={{ color: 'white' }} />
                  <span className='sub-button-text'>新建成员</span>
                </button>
                <button
                  className='admin-little-menu'
                  onClick={() => {
                    setGroupOpen(true)
                  }}
                >
                  <PlusCircleOutlined style={{ color: 'white' }} />
                  <span className='sub-button-text'>新建分组</span>
                </button>
              </div>
            )}
            <button
              className={component === 2 ? 'sider-button sider-button-clicked' : 'sider-button'}
              onClick={(_e) => {
                setComponent(2)
              }}
            >
              <IdcardOutlined />
              <span className='button-text'>数据管理</span>
            </button>
            {component === 2 && (
              <div>
                <button
                  className='admin-little-menu'
                  onClick={() => {
                    setRuleOpen(true)
                  }}
                >
                  <PlusCircleOutlined style={{ color: 'white' }} />
                  <span className='sub-button-text'>新建规则</span>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='admin-body-content'>
          {component === 0 ? (
            <DashboardPage />
          ) : component === 1 ? (
            <UserPage groupOptions={groupOptions} groupToId={groupToId} ref={userRef} />
          ) : (
            <DataPage
              groupOptions={groupOptions}
              userOptions={userOptions}
              permissionOptions={permissionOptions}
              dataPathOptions={dataPathOptions}
              groupToId={groupToId}
              ruleToId={ruleToId}
              ref={ruleRef}
            />
          )}
        </div>
      </div>
    </div>
  )
}
